import { Button } from '@any-ui-react/core';
import { useFormContext, useWatch } from 'react-hook-form';

import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { useEmployeeAccess } from '@/common/hooks/employees/useEmployeeAccess';
import type { EmployeePersonalInformationFormDataType, EmployeeVisaType } from '@/common/types';

import { VisaModal } from './VisaModal';
import { VisaTable } from './VisaTable';

interface VisaProps {
  onCreate: (data: EmployeeVisaType) => Promise<void>;
  onUpdate: (data: EmployeeVisaType) => Promise<void>;
  onRemove: (id: string) => Promise<void>;
}

export const Visa = ({ onCreate, onUpdate, onRemove }: VisaProps) => {
  const {
    formState: { errors },
    control,
  } = useFormContext<EmployeePersonalInformationFormDataType>();

  const { employeeDetail } = useEmployeeDetailContext();
  const isNewRecord = !employeeDetail.id;
  const visas = useWatch({ control, name: 'visas' });
  const { hasEmployeePersonalInformationEditAccess } = useEmployeeAccess();
  const isEditable = hasEmployeePersonalInformationEditAccess || isNewRecord;

  return (
    <div className="mb-6">
      <div className="mb-4 flex gap-2 items-center justify-between">
        <h1 className="font-semibold">Visa</h1>
        {isEditable && (
          <VisaModal isNewRecord={true} onSuccess={onCreate}>
            <Button variant="default">Add New Visa</Button>
          </VisaModal>
        )}
      </div>
      <VisaTable isEditable={isEditable} items={visas} loading={false} onRemove={onRemove} onUpdate={onUpdate} />
      {errors.visas && <span className="text-xs text-red-6">{errors.visas.message}</span>}
    </div>
  );
};
